import { render, staticRenderFns } from "./DocumentIdCard.vue?vue&type=template&id=7a16f7bf&scoped=true"
var script = {}
import style0 from "./DocumentIdCard.vue?vue&type=style&index=0&id=7a16f7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a16f7bf",
  null
  
)

export default component.exports